exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.card[data-v-d5247ba6] {\nborder-radius: 12px ;\npadding-left: 15px;\npadding-right: 15px;\n}\n\n", "", {"version":3,"sources":["/var/www/html/site-admin-panel-front/src/components/molecules/ReportChart.vue"],"names":[],"mappings":";AACA;AACA,qBAAqB;AACrB,mBAAmB;AACnB,oBAAoB;CACnB","file":"ReportChart.vue","sourcesContent":["\n.card[data-v-d5247ba6] {\nborder-radius: 12px ;\npadding-left: 15px;\npadding-right: 15px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d5247ba6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/molecules/ReportChart.vue
// module id = 2079
// module chunks = 0